import React from 'react';
import { _t, createLink } from 'utils';
import Section from 'screens/shared/section';
import { ACTIONS_TYPES } from 'redux/local';
import { ROUTE } from 'constant';
import CreateForm from './create';

const getLan = (e) => `LAN ${e?.properties?.lan}`;
export default ({ dcId, loadbalancers = [], history = {} }) => (
  <Section
    sectionTitle={_t('Load Balancers')}
    className="-m-t-24"
    createForm={<CreateForm dcId={dcId} />}
    createActionType={ACTIONS_TYPES.LOAD_BALANCER.CREATE}
    items={loadbalancers}
    itemIcon="sitemap"
    itemOnClick={(e) => history.push(createLink(ROUTE.DASHBOARD.LOAD_BALANCER, { dcId, id: e?.id }))}
    setItemTitle={(e) => e?.properties?.name}
    setItemDetails={(e) => e?.entities?.balancednics?.items?.map?.(getLan)?.join?.(', ') || _t('Select the NICs to be balanced')}
    isDeletePassword
  />
);
